
import { isEmpty } from 'lodash';
import moment from 'moment';
import AdsApi from '../libs/ads-request/ads-api';
import IDKITApi from '../libs/IDKITApi';

const ERROR_MESSAGE_LOGIN = 'Ocurrio un error, intenterlo mas tarde';
export default {
  data: () => ({
    errorMessage: '',
    isErrorLogin: false,
    errorMessageLogin: '',
    showError: false,
    orderId: '',
    token: '',
    brand: '',
    email: '',
    emailIdKit: '',
    orderStatus: null,
    showNoticePrivacy: false,
    showTutorial: 0,
    emailInvalid: false,
    notFoundOrders: false,
    initialStep: 0,
    persistent: true,
    lastSuperOrderId: null,
  }),
  mounted() {
    this.start();
    this.lastSuperOrderId = localStorage.getItem('superOrderId') ? localStorage.getItem('superOrderId') : this.$session.get('superOrderId');
  },
  methods: {
    async start() {
      const loaderText = this.$session.get('token') ? 'Validando sesión' : 'Iniciando sesión';
      this.loaderShow(loaderText);
      // Tomamos el email y el state inyectado por IDKIT
      this.email = this.$route.query.email;
      const { state } = this.$route.query;
      this.token = this.$route.query.token;
      this.brand = this.$route.query.brand;
      if (process.env.NODE_ENV !== 'production') this.orderId = localStorage.getItem('superOrderId') ? localStorage.getItem('superOrderId') : this.$session.get('superOrderId');
      else {
        this.orderId = localStorage.getItem('superOrderId') ? localStorage.getItem('superOrderId') : this.$session.get('superOrderId');
      }
      const orderIdUrl = this.$route.query.orderId
        ? this.$route.query.orderId : this.$route.query.orderid;
      if (!this.orderId) this.orderId = orderIdUrl;

      if (process.env.NODE_ENV !== 'production') this.orderStatus = this.$route.query.orderStatus;

      try {
        await this.startIDKitSession(state);
        await this.getPreLoginInfo();
      } catch (error) {
        this.showError = true;
      } finally {
        this.loaderHide();
      }
    },
    startIDKitSession(state) {
      return this.getIDKitSessionData(state);
    },
    getIDKitSessionData(state) {
      return IDKITApi.getIDKitSessionData(state)
        .then((data) => {
          this.emailIdKit = data.emailClient;
          this.$session.start(21600000);
          this.$session.set('email', data.emailClient);
          this.$session.set('state', state);
          this.$session.set('token', data.access_token);
          localStorage.setItem('token', data.access_token);
          this.$session.set('expire_date', moment().add(data.expires_in, 'seconds').format('YYYY-MM-DD HH:mm'));

          return data.emailClient;
        })
        .catch((error) => {
          throw this.validateResponseErrorMessage(error);
        });
    },
    startAdsSession() {
      return AdsApi.login(this.email, this.orderId)
        .then((res) => {
          const response = res.data;
          const { data } = response;
          const brand = this.$session.get('brand') !== '' ? this.$session.get('brand') : process.env.VUE_APP_BRAND;
          if (!response.success) {
            this.isErrorLogin = true;
            this.errorMessageLogin = response.errorDescription ?? ERROR_MESSAGE_LOGIN;
          } else if (data.orders.length === 0) {
            this.notFoundOrders = true;
            throw new Error('No se encontraron ordenes');
          } else {
            this.getDataAdviser(data.orders);
            this.$session.set('orderId', data.superOrderId);
            this.$session.set('orderIdDMS', data.superOrderIdDMS);
            this.$session.set('showAdditionalBudgets', false);
            this.$session.set('showPreInvoice', false);
            this.$session.set('showActivitiesList', false);
            this.$session.set('dealerId', data.dealerId);
            localStorage.setItem('dealerId', data.dealerId);
            this.$session.set('dealerName', data.dealerName);
            this.$session.set('dealerAddress', data.dealerDireccion);
            this.$session.set('dealerCity', data.dealerCiudad);
            this.$session.set('dealerState', data.dealerEstado);
            this.$session.set('plates', data.plates);
            this.$session.set('model', data.model);
            this.$session.set('year', data.years);
            this.$session.set('customerName', data.customerName);
            this.$session.set('customerRFC', data.customerRFC);
            this.$session.set('customerPhone', data.customerPhone);
            this.$session.set('customerPhoneCode', data.customerPhoneCode);
            this.$session.set('customerAddress', data.customerAddress);
            this.$session.set('orderComments', data.orderComments);
            this.$session.set('receptionKilometers', data.receptionKilometers);
            this.$session.set('dealerIdExt', data.dealerIdExt);
            this.$session.set('customerIdDMS', data.customerIdDMS);
            this.$session.set('orders', data.orders);
            this.$session.set('showTutorial', this.showTutorial);
            this.$session.set('nameContact', data.nameContact);
            this.$session.set('cellphoneContact', data.cellphoneContact);
            this.$session.set('emailContact', data.emailContact);
            localStorage.setItem('parentSuperOrder', data.parentSuperOrderIdDMS);
            localStorage.setItem('parentSuperOrderId', data.parentSuperOrderId);
            localStorage.setItem('ordersLogin', JSON.stringify(data.orders));
            localStorage.setItem('orderIdDMS', data.orders[0].orderIdDMS);
            if (data.parentSuperOrderId !== null) {
              localStorage.setItem('isParentOrder', true);
            } else {
              localStorage.setItem('isParentOrder', false);
            }
            if (this.orderStatus != null) this.$session.set('orderStatus', this.orderStatus);
            else this.$session.set('orderStatus', data.superOrderStatus);
            this.$store.commit('SET_LAYOUT', `${brand[0].toUpperCase()}${brand.substring(1)}Layout`);
            localStorage.setItem('originAuth', true);
            this.$router.push({ name: 'home' });
          }
        })
        .catch((error) => {
          throw error;
        });
    },
    getPreLoginInfo() {
      return AdsApi.preLogin(this.email, this.orderId)
        .then(async (response) => {
          const { data } = response;

          if (process.env.NODE_ENV === 'production' && this.emailIdKit !== data.customerEmail) {
            this.emailInvalid = true;
            throw new Error('Email inválido');
          }

          this.showTutorial = data.tutorial;

          const brand = !isEmpty(data.brand) ? data.brand.toLowerCase() : process.env.VUE_APP_BRAND;

          this.$session.set('email', this.email);
          this.$session.set('brand', brand);
          this.$session.set('urlDealerPrivacy', data.urlDealerPrivacy);
          this.$session.set('privacy', data.privacy);
          this.$session.set('transferData', data.transferData);
          this.showNoticePrivacy = data.privacy;
          await this.startAdsSession();
          this.loaderHide();
        })
        .catch((error) => {
          throw error;
        });
    },
    async logout() {
      this.loaderShow('Cerrando sesión');

      try {
        if (process.env.NODE_ENV === 'production') await IDKITApi.logout(this.$session.get('state'));

        this.$session.clear();

        this.$router.push({
          name: 'loginClient',
          query: { orderId: this.orderId },
        });
      } catch (error) {
        this.alertShow(error, 'error');
      } finally {
        this.loaderHide();
      }
    },
    getIDKitDevData() {
      return new Promise((accept) => {
        accept({
          username: 'development',
          firstname: 'John',
          lastname: 'Doe',
          roleId: 1,
          role: 'Client user',
        });
      });
    },
    getDataAdviser(orders) {
      const orderReception = orders.filter((item) => item.orderAdviserName !== null
      && item.orderAdviserEmail !== null);
      this.$session.set('adviserName', orderReception.length > 0 ? orderReception[0].orderAdviserName : '');
      this.$session.set('adviserCellphone', orderReception.length > 0 ? orderReception[0].orderAdviserCellphone : '');
      this.$session.set('adviserEmail', orderReception.length > 0 ? orderReception[0].orderAdviserEmail : '');
      this.$session.set('observations', orderReception.length > 0 ? orderReception[0].orderObservations : '');
    },
  },
};
